@if (crewInfo() && crewInfoValidated(); as validation) {
  <app-tabs-main [selectedIndex]="selectedIndex" [disabled]="!validation.active || validation.blocked || !validation.valid">
    <app-new-reservation newReservation></app-new-reservation>
  </app-tabs-main>
}
